import { transmit } from '@/lib/transmit'

type UseTransmitProps<Data> = {
    onMessage: (message: Data, unsubscribe: () => Promise<void>) => void
}

export function useTransmit<TData>({ onMessage }: UseTransmitProps<TData>) {
    async function subscribe(channel: string) {
        const subscription = transmit.subscription(channel)
        await subscription.create()

        return subscription.onMessage<TData>(message =>
            onMessage(message, () => subscription.delete()),
        )
    }

    return subscribe
}
